import { useMutation } from '@tanstack/react-query';
// import apiUpdateService from 'services/apiUpdateService';
import apiInputService from 'services/apiInputService';
import { ICreateWorkerProps } from './types';

const createWorker = async (body: ICreateWorkerProps) => {
  const { data } = await apiInputService.post(`/worker/create`, body);

  return data;
};

export const useCreateWorker = (options?: any) => {
  return useMutation(createWorker, {
    ...options,
  });
};
